export default __webpack_public_path__ + "static/media/license-bg-cn.2a044246.webp";